import { initSearchBlogEbookAuthor } from './modules/search/searchFilters';

initSearchBlogEbookAuthor();
